import { sounds, soundUrl } from "../data/sounds";
import useSound from "use-sound";
import { useRef } from "react";

const useCacheSoundEffects = () => {
  const data = useRef({});

  data.current = Object.entries(sounds).reduce((acc, [k, v]) => {
    const [play] = useSound(soundUrl + v);
    acc[k] = { play };

    return acc;
  }, {});

  return data.current;
};

export default useCacheSoundEffects;
